export default __webpack_public_path__ + "static/media/belongings_img.2f9671fc.svg";